import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'

export function ProtectedRoute() {
  const { session, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <div className="grid min-h-screen place-items-center text-slate-600">Carregando acesso…</div>
  }
  if (!session) return <Navigate to="/login" replace state={{ from: location }} />
  return <Outlet />
}
